import React, { useContext } from "react";
import { ControlpanelContext } from "../../../util/context";
import FreeTrialSelection from "../../components/FreeTrialSelection";
import InputFieldService from "../../components/InputFieldService";
import InputSearchField from "../../components/InputSearchField";
import "./CreatePlanSubscription.scss";
import OverflowTooltip from "./OverflowTooltip";

export default function CreatePlanSubscription() {
    const { accountSetup, setAccountSetup, accountSetupError, setAccountSetupError,
        sequenceData
    } = useContext(ControlpanelContext);

    return (
        <div>
            <div className="inline-container">
                <div className="left-section">
                    <div id="plan-name">
                        <div className="label">Plan name<span style={{color:"#FE5050"}}>*</span></div>
                        <InputSearchField
                            value={accountSetup.plan_name}
                            onChange={(val) => {
                                setAccountSetupError({ ...accountSetupError, plan_name: "" })
                                setAccountSetup({ ...accountSetup, plan_name: val })
                            }}
                            label={"Enter plan name"}
                            maxLength={100}
                            error={accountSetupError.plan_name}
                            required={true}
                        />
                    </div>
                    {/* <div id="trial">
                        <FreeTrialSelection
                            value={accountSetup.trail_period}
                            onChange={(val) => {
                                if (!/^\d*$/.test(val)) return;
                                if (val.length > 2) return;
                                setAccountSetupError({ ...accountSetupError, trail_period: "" })
                                setAccountSetup({ ...accountSetup, trail_period: val })
                            }}
                            error={accountSetupError.trail_period}
                        />
                    </div> */}
                    <div id="plan-name" style={{ marginTop: "50px" }}>
                        <div className="label">Plan type</div>
                        <InputFieldService value="Service" showIcon={false} />
                    </div>
                </div>

                <div className="vertical-line"></div>

                <div className="right-section" style={{ marginLeft: "20px" }}>
                    <div id="plan-name">
                        <div className="label">Sequence ID<span style={{color:"#FE5050"}}>*</span></div>
                        <InputSearchField
                            value={accountSetup.plan_order}
                            type="number"
                            label={"Order sequence of plan"}
                            onChange={(val) => {
                                if (!/^\d*$/.test(val)) return;
                                setAccountSetupError({ ...accountSetupError, plan_order: "" })
                                setAccountSetup({ ...accountSetup, plan_order: val })
                            }}
                            error={accountSetupError.plan_order}
                        />
                    </div>
                    <div className="sequence-container">
                        <h3 className="sequence-title">Current sequence</h3>
                        <div className="sequence-list">
                            {sequenceData.map((item) => (
                                <div className="sequence-item" style={{ display: 'flex' }} key={item.id}>
                                    <span className="sequence-number" style={{marginRight:"20px"}}>{item.id}</span>
                                    <OverflowTooltip text={item.name} />

                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}